<template>
  <div class="profile-wrapper">
    <div v-for="(profile,i) in profiles" :key="profile.id" class="profile-card">
      <div class="avatar-wrapper" @click="onSelected(profile)">
        <img :src="getAvatar(profile.sex)" />
      </div>
      <div class="profile-main" @click="onSelected(profile)">
        <div class="pname">
          {{profile.name}}
          <span class="relationship">{{profile.relation}}</span>

        </div>
        <div class="mobile">联系手机： {{profile.phone|mask("phone")}}</div>
        <div class="idcard">证件号码： {{profile.idcard|mask("idcard")}}</div>
      </div>
      <div class="profile-edit-wrap">
        <span class="profile-edit" @click="editProfile(profile)">
          <van-icon name="edit" class="van-edit" />修改</span>
      </div>
    </div>
    <div class="profile-add">
      <router-link to="/user/addprofile">
        <van-icon name="add-o" size="18" />
        <div>新增体检人员</div>
      </router-link>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .profile-wrapper {
    padding: 16px;
  }

  .profile-card {
    background: #fff;
    border-radius: 5px;
    border: 1px solid rgba(215, 215, 215, 0.45);
    box-shadow: 3px 3px 8px rgba(215, 215, 215, 0.35);
    display: flex;
    margin-bottom: 20px;

    .avatar-wrapper {
      margin: auto 0;
      text-align: center;

      img {
        width: 64px;
        height: 64px;
        margin: 12px;
      }
    }

    .profile-main {
      flex: 1;
      padding: 12px;

      .pname {
        font-size: 16px;
        margin-bottom: 8px;
      }

      .relationship {
        border-radius: 3px;
        padding: 3px 6px;
        font-size: 12px;
        color: #ff9933;
        border: 1px solid #ff9933;
        margin-left: 16px;
      }



      .mobile {
        font-size: 13px;
        color: #a1a1a1;
        line-height: 24px;
      }

      .idcard {
        font-size: 13px;
        color: #a1a1a1;
        line-height: 24px;
      }
    }

    .profile-edit-wrap {
      padding: 12px 12px 12px 0;

      .profile-edit {
        font-size: 12px;
        padding: 4px 0;
      }
    }
  }

  .profile-add {
    text-align: center;
    padding: 12px;
    border-radius: 5px;
    border: 1px dashed rgba(215, 215, 215, 0.45);
    background: #fafafa;
    font-size: 14px;
  }
</style>

<script>
  import * as api_user from "@/api/user";
  export default {
    data() {
      return {
        profiles: []
      };
    },
    props: {
      addProfile: {
        type: Boolean,
        default: function () {
          return false;
        }
      }
    },
    async mounted() {
      let result = await api_user.getUserProfiles();
      if (result && result.data) {
        this.profiles = result.data;
      }
    },
    methods: {
      getAvatar(sex) {
        switch (sex) {
          case 1:
            return require("../assets/images/avatar-male.png");
            break;
          case 2:
            return require("../assets/images/avatar-female.png");
            break;
          default:
            return require("../assets/images/avatar-male.png");
            break;
        }
      },
      onSelected(profile) {
        this.$emit("select", profile);
      },
      editProfile(profile) {
        this.$router.push({
          path: '/user/editProfile',
          query: {
            pid: profile.id
          }
        });
      }
    }
  };
</script>